import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;
const email = sessionStorage.getItem('email');

const useLogout = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await axios.get(`${baseUrl}/account/logout/${email}`)
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('merchantId');
      sessionStorage.removeItem('roles');
      sessionStorage.removeItem('tokenExpiry')
      sessionStorage.removeItem('email');
      sessionStorage.removeItem('merchantDetails');
      sessionStorage.removeItem('currentRoute')
      sessionStorage.removeItem('name')
      localStorage.removeItem('authenticated')
      navigate('/login');
    } catch (error) {
      console.error('Logout failed', error)
  };
  }

  return logout;
};

export default useLogout;
